/**
 * Resolved at build time so unused adapters tree-shake away. `platform.kind` is
 * for copy and affordances only — a conditional about clinical behaviour keyed
 * on platform is a bug.
 */
import type { Platform } from '@/platform/types'
import { webPlatform } from '@/platform/web'

const configured = import.meta.env.VITE_PLATFORM ?? 'web'

function resolve(): Platform {
  switch (configured) {
    case 'mobile':
    case 'desktop':
      // The shells supply their adapter through this switch when they build.
      // Until then the web adapter is the honest answer: it works everywhere.
      return webPlatform
    default:
      return webPlatform
  }
}

export const platform: Platform = resolve()
export type { Platform, PlatformKind, CapturedFile } from '@/platform/types'
